export const PHONE_CODES = [{ value: "965", label: "+965" }];
